import PropTypes from "prop-types";

export const PharmGKBGeneType = PropTypes.shape({
  version: PropTypes.string,
  chemical_relations: PropTypes.arrayOf(
    PropTypes.shape({
      association: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      // normalized_drug: PropTypes.arrayOf(PropTypes.string),
      pharmacodynamic: PropTypes.bool,
      pharmacokinetic: PropTypes.bool,
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
      drug_label_annotations: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          testing_level: PropTypes.string,
          biomarker_flag: PropTypes.string,
          cancer_genome: PropTypes.bool,
        })
      ),
    })
  ),
  disease_relations: PropTypes.arrayOf(
    PropTypes.shape({
      association: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      pharmacodynamic: PropTypes.bool,
      pharmacokinetic: PropTypes.bool,
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  guidelines: PropTypes.arrayOf(
    PropTypes.shape({
      latest_update: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      recommended: PropTypes.bool,
      summary: PropTypes.string,
      chemical_relations: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          // normalized_drug: PropTypes.arrayOf(PropTypes.string),
        })
      ),
    })
  ),
});
